// Upload.jsx
import React from 'react'
import MyNavbar from '../components/MyNavbar'
import { Outlet } from 'react-router-dom'

export default function Upload() {
    return (
        <>
            <MyNavbar />
            <div className="container mt-4">
                <h3 className="text-center">Create Post</h3>
                <Outlet />
            </div>
        </>
    )
}
